// The mass units Emissions can display its totals in, listed here so that the users table can store each user's choice.
// Everything else about these units lives in tri-shared/services/emissions/emissions-mass-units.ts, which must
// define every one of them.

// In the order screens should offer them (US customary units, then metric, each from largest to smallest):
export const emissionsMassUnitIDs = [
  'tons',
  'hundredweight',
  'pounds',
  'ounces',
  'grains',
  'tonnes',
  'kilograms',
  'grams',
  'milligrams',
] as const;

export type EmissionsMassUnitID = (typeof emissionsMassUnitIDs)[number];

export const emissionsMassUnitDefault: EmissionsMassUnitID = 'tons';
